import React from 'react';
import FloatingChatWidget from './components/FloatingChatWidget';
import { Typography, Box, Button } from '@mui/material';
import './App.css';

interface AppProps {
  webhookUrl?: string;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  theme?: any;
  layout?: any;
  behavior?: any;
}

function App({
  webhookUrl = "https://n8n.smartnoticeboard.io/webhook/b45daf0e-cfd7-4f5c-9f51-03414f6a1128/chat", // Default URL
  position = "bottom-right",
  theme = {},
  layout = {},
  behavior = {}
}: AppProps) {
  
  // Test function to simulate HTML parsing
  const testHTMLParsing = () => {
    const testHTML = '<p>You can check out our <a href=\\\"https://alphawolflabs.com/product-category/hgh/\\\" target=\\\"_blank\\\" rel=\\\"noopener\\\">HGH/Peptides category</a> for peptides like PT-141 (10mg).</p>';
    console.log('Testing HTML parsing with:', testHTML);
    
    // Simulate the fixDoubleEscapedHTML function
    const fixDoubleEscapedHTML = (html: string): string => {
      if (!html || typeof html !== 'string') return html;
      
      // Fix double-escaped quotes: \\\" -> \"
      let fixed = html.replace(/\\\"/g, '"');
      
      // Fix double-escaped backslashes: \\\\ -> \\
      fixed = fixed.replace(/\\\\/g, '\\');
      
      // Fix other common double-escaped characters
      fixed = fixed.replace(/\\n/g, '\n');
      fixed = fixed.replace(/\\t/g, '\t');
      fixed = fixed.replace(/\\r/g, '\r');
      
      return fixed;
    };
    
    const result = fixDoubleEscapedHTML(testHTML);
    console.log('Fixed HTML:', result);
    alert(`Original: ${testHTML}\n\nFixed: ${result}`);
  };

  return (
    <div className="App">
      {/* This content is for development view and won't be in the embedded version unless you want it to be */}
      <Box sx={{ textAlign: 'center', color: 'white', mb: 4 }}>
        <Typography variant="h3" sx={{ mb: 2, fontWeight: 'bold' }}>
          Welcome to Alpha Wolf Labs
        </Typography>
        <Typography variant="h6" sx={{ opacity: 0.9, mb: 3 }}>
          Click the chat icon in the bottom right to get started!
        </Typography>
        <Button 
          variant="contained" 
          onClick={testHTMLParsing}
          sx={{ mb: 2 }}
        >
          Test HTML Parsing
        </Button>
      </Box>
      
      <FloatingChatWidget
        webhookUrl={webhookUrl}
        position={position}
        theme={{
          primary: '#1976d2',
          secondary: '#dc004e',
          background: '#ffffff',
          text: '#333333',
          userMessageBg: '#e3f2fd',
          userMessageText: '#000000',
          botMessageBg: '#f5f5f5',
          botMessageText: '#000000',
          headerBg: '#1976d2',
          headerText: '#ffffff',
          inputBg: '#ffffff',
          inputText: '#000000',
          borderRadius: '8px',
          fontFamily: 'Arial, sans-serif',
          ...theme
        }}
        layout={{
          showHeader: true,
          showMinimize: true,
          showClose: true,
          showAttachButton: true,
          headerTitle: 'Alpha WOlf Labs',
          headerSubtitle: 'Powered by AKITS',
          avatarSize: 32,
          messageMaxWidth: '70%',
          messageSpacing: 6,
          inputHeight: 48,
          ...layout
        }}
        behavior={{
          autoScroll: true,
          showTimestamps: true,
          showAgentName: true,
          showTypingIndicator: true,
          allowFileUpload: true,
          maxFileSize: 5,
          allowedFileTypes: ['image/*', 'application/pdf'],
          ...behavior
        }}
      />
    </div>
  );
}

export default App;
